
class SigninWithGoogleRequest {
    constructor(username,fistname,lastname){
        this.UserName=username;
        this.FirstName=fistname;
        this.LastName=lastname;
    }
}

export default SigninWithGoogleRequest;